<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
      <!-- <template v-slot:divider>
        <v-icon>mdi-forward</v-icon>
      </template> -->
    </v-breadcrumbs>

    <!-- <v-card> -->
    <v-row dense
           class="d-flex mx-16">
      <v-col cols="3">
        <v-btn icon
               small
               outlined
               @click="showOrHide()">
          <v-icon v-if="isShowFilter">mdi-chevron-double-left</v-icon>
          <v-icon v-else>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-col>
      <v-col :cols="col2">
        <!-- <knowledge-show-filter :cancer-selected="cancer_selected"
                                 :gene-selected="gene_selected"
                                 :as-selected="as_selected"
                                 :site-selected="site_selected"
                                 :bio-func-selected="bio_func_selected"
                                 :cell-line-selected="cell_line_selected"
                                 :pubmed-selected="pubmed_selected"
                                 :year-selected="year_selected"></knowledge-show-filter> -->
        <v-alert color="info"
                 text
                 dense>
          <v-icon dark
                  color="info"
                  v-show="isShowTips">mdi-hand-pointing-left</v-icon>
          <span class="ml-2"
                v-show="isShowTips">Start searching by selecting one or more fields</span>
          <v-btn small
                 color="error"
                 class="mx-1"
                 @click="refreshAll()"
                 v-show="!isShowTips">
            <v-icon left>mdi-refresh</v-icon>
            Clear
          </v-btn>

          <!-- cancer_selected -->
          <v-btn v-show="cancer_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshCancer()">Cancer Type</v-btn>
          <v-btn v-show="cancer_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="cancer_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="cancer_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(cancer, index) in cancer_selected"
               :key="index">
            <v-btn v-show="cancer_selected.length > 0 && index < cancer_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="cancer_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     cancer_selected_show = cancer_selected.length;">
              {{cancer}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == cancer_selected_show"
                   @click="cancer_selected_show=cancer_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="cancer_selected_show > 2"
                 @click="cancer_selected_show=2">...Less</v-btn>
          <span v-show="cancer_selected.length > 1">)</span>
          <v-btn v-show="cancer_selected.length>0 && gene_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- gene_selected -->
          <v-btn v-show="gene_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshGene()">Gene Name</v-btn>
          <v-btn v-show="gene_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="gene_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="gene_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(gene, index) in gene_selected"
               :key="gene">
            <v-btn v-show="gene_selected.length > 0 && index < gene_selected_show"
                   class="mx-1 mt-1"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   small
                   color="info"
                   @click="gene_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     gene_selected_show = gene_selected.length;">
              {{gene}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == gene_selected_show"
                   @click="gene_selected_show=gene_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="gene_selected_show > 3"
                 @click="gene_selected_show=3">...Less</v-btn>
          <span v-show="gene_selected.length > 1">)</span>
          <v-btn v-show="gene_selected.length > 0 && as_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- as_selected -->
          <v-btn v-show="as_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshASType()">AS Type</v-btn>
          <v-btn v-show="as_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="as_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="as_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(as, index) in as_selected"
               :key="as">
            <v-btn v-show="as_selected.length > 0 && index < as_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="as_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     as_selected_show = as_selected.length;">
              {{as}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == as_selected_show"
                   @click="as_selected_show=as_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="as_selected_show > 3"
                 @click="as_selected_show=3">...Less</v-btn>
          <span v-show="as_selected.length > 1">)</span>
          <v-btn v-show="as_selected.length > 0 && site_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- site_selected -->
          <v-btn v-show="site_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshSite()">Primary Site</v-btn>
          <v-btn v-show="site_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="site_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="site_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(site, index) in site_selected"
               :key="site">
            <v-btn v-show="site_selected.length > 0 && index < site_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="site_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     site_selected_show = site_selected.length;">
              {{site}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == site_selected_show"
                   @click="site_selected_show=site_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="site_selected_show > 3"
                 @click="site_selected_show=3">...Less</v-btn>
          <span v-show="site_selected.length > 1">)</span>
          <v-btn v-show="site_selected.length > 0 && bio_func_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- bio_func_selected -->
          <v-btn v-show="bio_func_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshBioFunc()">Biological Function</v-btn>
          <v-btn v-show="bio_func_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="bio_func_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="bio_func_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(bio_func, index) in bio_func_selected"
               :key="bio_func">
            <v-btn v-show="bio_func_selected.length > 0 && index < bio_func_selected_show"
                   class="mx-1 mt-1"
                   small
                   outlined
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="bio_func_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     bio_func_selected_show = bio_func_selected.length;">
              {{bio_func}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == bio_func_selected_show"
                   @click="bio_func_selected_show=bio_func_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="bio_func_selected_show > 3"
                 @click="bio_func_selected_show=3">...Less</v-btn>
          <span v-show="bio_func_selected.length > 1">)</span>
          <v-btn v-show="bio_func_selected.length > 0 && cell_line_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- cell_line_selected -->
          <v-btn v-show="cell_line_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshCellLine()">Cell Line</v-btn>
          <v-btn v-show="cell_line_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="cell_line_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="cell_line_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(cell_line, index) in cell_line_selected"
               :key="cell_line">
            <v-btn v-show="cell_line_selected.length > 0 && index < cell_line_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="cell_line_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     cell_line_selected_show = cell_line_selected.length;">
              {{cell_line}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == cell_line_selected_show"
                   @click="cell_line_selected_show=cell_line_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="cell_line_selected_show > 3"
                 @click="cell_line_selected_show=3">...Less</v-btn>
          <span v-show="cell_line_selected.length > 1">)</span>
          <v-btn v-show="cell_line_selected.length > 0 && year_selected"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- year_selected -->
          <v-btn v-show="year_selected"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshYear()">Published Year</v-btn>
          <v-btn v-show="year_selected"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="year_selected"
                 class="mx-1"
                 small
                 color="info"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshYear()">
            {{year_selected}}
          </v-btn>
          <v-btn v-show="year_selected && pubmed_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- pubmed_selected -->
          <v-btn v-show="pubmed_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshPubmed()">PubMed ID</v-btn>
          <v-btn v-show="pubmed_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="pubmed_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="pubmed_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(pubmed, index) in pubmed_selected"
               :key="pubmed">
            <v-btn v-show="pubmed_selected.length > 0 && index < pubmed_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="pubmed_selected.splice(index, 1);
                     loading = true;
                     getSpliceKnowledge();
                     pubmed_selected_show = pubmed_selected.length;">
              {{pubmed}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == pubmed_selected_show"
                   @click="pubmed_selected_show=pubmed_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="pubmed_selected_show > 3"
                 @click="pubmed_selected_show=3">...Less</v-btn>
          <span v-show="pubmed_selected.length > 1">)</span>
        </v-alert>
      </v-col>

      <v-col cols="3"
             v-show="isShowFilter">
        <v-list outlined
                rounded
                dense>
          <!-- Cancer Type -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Cancer Type(s)</v-list-item-title>
              <v-icon right
                      @click.stop="
                        isShowCancerSearchBox=!isShowCancerSearchBox">mdi-magnify</v-icon>
              <v-icon right
                      v-show="cancer_selected.length > 0"
                      @click.stop="refreshCancer()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Cancer Type"
                        v-show="isShowCancerSearchBox"
                        v-model="cancer_select"
                        hide-no-data
                        outlined
                        dense
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="cancer_loading"
                        :search-input.sync="cancer_search"
                        :error-messages="cancer_error_message">
            </v-combobox>
            <v-chip-group class="mx-6"
                          multiple
                          column
                          center-active
                          v-model="cancer_selected">
              <div v-for="(cancer, index) in cancer_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="cancer"
                        v-show="index < cancer_index">
                  <span>
                    {{ cancer }}
                  </span>
                </v-chip>
                <v-btn class="grey--text text-caption"
                       text
                       small
                       outlined
                       v-show="index == cancer_index"
                       @click="showMoreCancer()">(+{{ cancer_items.length - cancer_index }} More)
                </v-btn>
              </div>
              <v-btn class="grey--text text-caption"
                     text
                     small
                     outlined
                     v-show="cancer_index == cancer_items.length"
                     @click="showLessCancer()">Less
              </v-btn>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Gene Name -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Gene Name(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="gene_selected.length > 0"
                      @click.stop="refreshGene()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Gene Name"
                        v-model="gene_selected"
                        outlined
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="gene_loading"
                        :items="gene_items"
                        :search-input.sync="gene_search"
                        :messages="gene_message"
                        :error-messages="gene_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small>
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ gene_selected.length - 3 }} More)
                </span>
              </template>
            </v-combobox>
          </v-list-group>
          <v-divider></v-divider>

          <!-- AS Type -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>AS Type(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="as_selected.length > 0"
                      @click.stop="refreshASType()">mdi-refresh</v-icon>
            </template>
            <v-chip-group class="mx-6"
                          v-model="as_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(astype, index) in as_items"
                   :key="index">
                <v-chip small
                        :value="astype"
                        filter>
                  <span>
                    {{ astype }}
                  </span>
                </v-chip>
              </div>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Primary Site -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Primary Site(s)</v-list-item-title>
              <v-icon right
                      @click.stop="isShowSiteSearchBox = !isShowSiteSearchBox">mdi-magnify</v-icon>
              <v-icon right
                      v-show="site_selected.length > 0"
                      @click.stop="refreshSite()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Primary Site"
                        v-show="isShowSiteSearchBox"
                        v-model="site_select"
                        hide-no-data
                        outlined
                        dense
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="site_loading"
                        :search-input.sync="site_search"
                        :error-messages="site_error_message">
            </v-combobox>
            <v-chip-group class="mx-6"
                          v-model="site_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(site, index) in site_items"
                   :key="index">
                <v-chip small
                        :value="site"
                        filter
                        v-show="index < site_index">
                  <span>
                    {{ site }}
                  </span>
                </v-chip>
                <v-btn class="grey--text text-caption"
                       text
                       small
                       outlined
                       v-show="index == site_index"
                       @click="showMoreSite()">(+{{ site_items.length - site_index }} More)
                </v-btn>
              </div>
              <v-btn class="grey--text text-caption"
                     text
                     small
                     outlined
                     v-show="site_index == site_items.length"
                     @click="showLessSite()">Less
              </v-btn>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Biological Function -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Biological Function(s)</v-list-item-title>
              <v-icon right
                      @click.stop="isShowBioFuncSearchBox = !isShowBioFuncSearchBox">mdi-magnify</v-icon>
              <v-icon right
                      v-show="bio_func_selected.length > 0"
                      @click.stop="refreshBioFunc()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Biological Function"
                        v-show="isShowBioFuncSearchBox"
                        v-model="bio_func_select"
                        hide-no-data
                        outlined
                        dense
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="bio_func_loading"
                        :search-input.sync="bio_func_search"
                        :error-messages="bio_func_error_message">
            </v-combobox>
            <v-chip-group class="mx-6"
                          v-model="bio_func_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(bio_func, index) in bio_func_items"
                   :key="index">
                <v-chip small
                        :value="bio_func"
                        filter
                        v-show="index < bio_func_index">
                  <span>
                    {{ bio_func }}
                  </span>
                </v-chip>
                <v-btn class="grey--text text-caption"
                       text
                       small
                       outlined
                       v-show="index == bio_func_index"
                       @click="showMoreBioFunc()">(+{{ bio_func_items.length - bio_func_index }} More)
                </v-btn>
              </div>
              <v-btn class="grey--text text-caption"
                     text
                     small
                     outlined
                     v-show="bio_func_index == bio_func_items.length"
                     @click="showLessBioFunc()">Less
              </v-btn>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Cell Line -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Cell Line(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="cell_line_selected.length > 0"
                      @click.stop="refreshCellLine()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Cell Line"
                        v-model="cell_line_selected"
                        outlined
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="cell_line_loading"
                        :items="cell_line_items"
                        :search-input.sync="cell_line_search"
                        :messages="cell_line_message"
                        :error-messages="cell_line_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small>
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ cell_line_selected.length - 3 }} More)
                </span>
              </template>
            </v-combobox>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Coordinate Range -->
          <!-- <v-list-group append-icon=""
                          dense>
              <template v-slot:activator>
                <v-icon left>mdi-menu-right</v-icon>
                <v-list-item-title>Coordinate Range</v-list-item-title>
                <v-icon right>mdi-magnify</v-icon>
                <v-icon right
                        v-show="chr || coordinate_start || coordinate_end"
                        @click.stop="refreshCoordinateRange()">mdi-refresh</v-icon>
              </template>
              <v-select class="mx-6"
                        :items="chrList"
                        label="Chr"
                        v-model="chr"
                        dense
                        outlined></v-select>
              <div class="d-flex flex-row mx-6 mt-n4">
                <v-text-field label="Coordinate Start"
                              placeholder="Placeholder"
                              outlined
                              dense
                              v-model="coordinate_start"
                              type="number"></v-text-field>
                <v-text-field label="Coordinate End"
                              placeholder="Placeholder"
                              outlined
                              dense
                              v-model="coordinate_end"
                              type="number"></v-text-field>
              </div>
            </v-list-group>
            <v-divider></v-divider> -->

          <!-- Year -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Published Year</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="year_selected"
                      @click.stop="refreshYear()">mdi-refresh</v-icon>
            </template>
            <v-select class="mx-6"
                      :items="yearList"
                      label="Year"
                      v-model="year_selected"
                      dense
                      outlined></v-select>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Pubmed ID -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>PubMed ID</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="pubmed_selected.length > 0"
                      @click.stop="refreshPubmed()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="PubMed ID"
                        type="number"
                        v-model="pubmed_selected"
                        outlined
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="pubmed_loading"
                        :items="pubmed_items"
                        :search-input.sync="pubmed_search"
                        :messages="pubmed_message"
                        :error-messages="pubmed_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small>
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ pubmed_selected.length - 3 }} More)
                </span>
              </template>
            </v-combobox>
          </v-list-group>
        </v-list>
      </v-col>

      <v-col :cols="col2">
        <!-- download function -->
        <div class="my-3"
             v-if="selected.length > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success"
                     dark
                     v-bind="attrs"
                     v-on="on"
                     rounded
                     small
                     class="ml-2">
                <span class="font-weight-bold">Download</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="selected"
                              name="Experimentally_supported_AS_events.xls">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="selected"
                              name="Experimentally_supported_AS_events.csv">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      v-model="selected"
                      class="data-table-style mt-1"
                      :headers="selectedHeaders"
                      fixed-header
                      :items="filteredSpliceVariant"
                      item-key="_id"
                      :search="search"
                      show-select
                      :single-select="singleSelect"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      hide-default-footer
                      :page.sync="currentPage"
                      :items-per-page="pageSize"
                      :group-by="groupBy"
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <!-- group-slot -->
          <!-- <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
              <v-btn @click="toggle"
                     small
                     icon
                     :ref="group"
                     :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
              {{ group }}
            </td>
          </template> -->

          <!-- show top pagination -->
          <!-- <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer show-first-last-page
                             :pagination="pagination"
                             :options="options"
                             @update:options="updateOptions"
                             :items-per-page-options="pageSizes"
                             items-per-page-text="Rows per page:" />
            </template> -->

          <!-- item.event_id slot -->
          <template v-slot:[`item.event_id`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.event_id}}</span>
              </template>
              <span><span class="error--text font-weight-bold">Event ID: </span> Gene _ Chromsome _ Strand _ AS Type _ Event Coordinates</span>
            </v-tooltip>
          </template>
          <!-- item.as_model_id slot -->
          <template v-slot:[`item.as_model_id`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.as_model_id}}</span>
              </template>
              <span><span class="error--text font-weight-bold">AS Model ID: </span>Gene _ Chromsome _ Strand _ AS Type _ AS Model Coordinates</span>
            </v-tooltip>
          </template>
          <!-- item.gene_name slot -->
          <template v-slot:[`item.gene_name`]="{item}">
            <a @click="goToGeneSearchResult(item.gene_name)"> <span class="font-weight-bold">{{item.gene_name}}</span>
            </a>
          </template>

          <!-- item.cancer_name slot -->
          <template v-slot:[`item.cancer_name`]="{item}">
            <span v-if="!item.cancer_name.includes(',')">{{item.cancer_name}}</span>
            <v-tooltip bottom
                       v-else>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.cancer_name.split(', ')[0]}} ...</span>
              </template>
              <span>{{item.cancer_name}}</span>
            </v-tooltip>
          </template>

          <!-- header.methods slot -->
          <template v-slot:[`header.methods`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>existent: <v-icon small
                        color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                        color="error">mdi-close-circle-outline</v-icon></span>
            </v-tooltip>
          </template>

          <!-- header.regulatory_mechanism slot -->
          <template v-slot:[`header.regulatory_mechanism`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>existent: <v-icon small
                        color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                        color="error">mdi-close-circle-outline</v-icon></span>
            </v-tooltip>
          </template>

          <!-- header.biological_function slot -->
          <template v-slot:[`header.biological_function`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>existent: <v-icon small
                        color="success">mdi-check-circle-outline</v-icon><br>non-existent: <v-icon small
                        color="error">mdi-close-circle-outline</v-icon></span>
            </v-tooltip>
          </template>

          <!-- header.regulatory_network slot -->
          <template v-slot:[`header.regulatory_network`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Network</span>
            </v-tooltip>
          </template>

          <!-- header.regulatory_explorer slot -->
          <template v-slot:[`header.regulatory_explorer`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Explorer</span>
            </v-tooltip>
          </template>

          <!-- header.survival slot -->
          <template v-slot:[`header.survival`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Survival Analysis</span>
            </v-tooltip>
          </template>

          <!-- header.staging slot -->
          <template v-slot:[`header.staging`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Cancer Staging Analysis</span>
            </v-tooltip>
          </template>

          <!-- item.methods slot -->
          <template v-slot:[`item.methods`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">
                  <v-icon v-if='item.methods !== ("" || "-" || "NA")'
                          color="success">mdi-check-circle-outline</v-icon>
                  <v-icon v-else
                          color="error">mdi-close-circle-outline</v-icon>
                </span>
              </template>
              <span>{{item.methods}}</span>
            </v-tooltip>
          </template>

          <!-- item.regulatory_mechanism slot -->
          <template v-slot:[`item.regulatory_mechanism`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">
                  <v-icon v-if='item.regulatory_mechanism !== ("" || "-" || "NA")'
                          color="success">mdi-check-circle-outline</v-icon>
                  <v-icon v-else
                          color="error">mdi-close-circle-outline</v-icon>
                </span>
              </template>
              <span>{{item.regulatory_mechanism}}</span>
            </v-tooltip>
          </template>

          <!-- item.biological_function slot -->
          <template v-slot:[`item.biological_function`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">
                  <v-icon v-if='item.biological_function !== ("" || "-" || "NA")'
                          color="success">mdi-check-circle-outline</v-icon>
                  <v-icon v-else
                          color="error">mdi-close-circle-outline</v-icon>
                </span>
              </template>
              <span>{{item.biological_function}}</span>
            </v-tooltip>
          </template>

          <!-- item.pubmed_id slot -->
          <template v-slot:[`item.pubmed_id`]="{item}">
            <a :href="pubmedLink+item.pubmed_id"
               target="_blank">{{item.pubmed_id}}</a>
          </template>

          <!-- item.title slot -->
          <template v-slot:[`item.title`]="{item}">
            <span v-if="item.title.length <= 100">{{item.title}}</span>
            <v-tooltip bottom
                       v-else>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.title.slice(0, 100) + '...'}}</span>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
          </template>

          <!-- item.visualization slot -->
          <template v-slot:[`item.visualization`]="{item}">
            <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                   color="info"
                   icon
                   :disabled="['Complex', 'AF', 'AL'].includes(item.as_type)">
              <v-icon>mdi-tune</v-icon>
            </v-btn>
          </template>

          <!-- item.regulatory_network slot -->
          <template v-slot:[`item.regulatory_network`]="{item}">
            <v-btn @click="goToRegulationNetwork(item.gene_name)"
                   color="info"
                   icon>
              <svg class="icon"
                   aria-hidden="true">
                <use xlink:href="#icon-icon-copy"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.regulatory_explorer slot -->
          <template v-slot:[`item.regulatory_explorer`]="{item}">
            <v-btn @click="goToRegulationExplorer(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="grey"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
                <use xlink:href="#icon-GridView-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-GridView-oncoprint"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.survival slot -->
          <template v-slot:[`item.survival`]="{item}">
            <v-btn @click="goToSurvival(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
                <use xlink:href="#icon-linechart-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-linechart"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.staging slot -->
          <template v-slot:[`item.staging`]="{item}">
            <v-btn @click="goToStaging(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
                <use xlink:href="#icon-xiangxiantu-disable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-xiangxiantu"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.details slot -->
          <template v-slot:[`item.details`]="{item}">
            <v-btn @click="goToDetails(item.event_id, item.cancer_name, item.pubmed_id)"
                   color="info"
                   icon>
              <v-icon>mdi-chevron-right-circle</v-icon>
            </v-btn>
          </template>

          <!-- header.data-table-select slot-->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox color="success"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </template>

          <!-- item.data-table-select slot -->
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template>
        </v-data-table>

        <div class="d-flex justify-center mt-2 mb-n5">
          <span class="text-body-1 mt-3">Items per page</span>
          <v-select v-model="pageSize"
                    dense
                    outlined
                    :items="pageSizes"
                    class="pagesize-select mt-1 mx-2"
                    @input="handlePageSizeChange(pageSize)">
          </v-select>
          <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
            items </span>
          <v-pagination v-model="currentPage"
                        color="info"
                        :length="totalPages"
                        :total-visible="6"
                        class="mx-1"
                        @input="handlePageChange"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right">
          </v-pagination>
          <span class="text-body-1 mt-2 mx-2">Page</span>
          <v-text-field outlined
                        dense
                        v-model="whichPage"
                        type="number"
                        class="jump-select"
                        append-icon="">
          </v-text-field>
          <v-btn color=""
                 depressed
                 outlined
                 class="mx-2"
                 @click="jumpPage()">Jump</v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <back-to-top></back-to-top>
  </v-container>
</template>

<script>
import {
  getSpliceKnowledge,
  getAllGeneFromSV, getAllCancerFromSV,
  getAllBiologicalFunctionFromSV, getAllPrimarySiteFromSV,
  getAllCellLineFromSV, getAllPubmedFromSV
} from 'node/browse';
import JsonExcel from 'vue-json-excel';
import BackToTop from '@/components/main/BackToTop';
// import KnowledgeShowFilter from './KnowledgeShowFilter';

export default {
  name: 'Knowledge',
  components: {
    JsonExcel,
    BackToTop
    // KnowledgeShowFilter,
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Browse',
          disabled: true,
        },
        {
          text: 'CASE (Cancer Associated Splicing Events)',
          disabled: true,
        },
      ],
      isShowFilter: true,
      col2: 9,

      isShowTips: true,
      isShowAnd: false,
      isShowDeleteLine: false,

      // Filter by Cancer Type:
      cancer_selected: [],
      cancer_select: null,
      cancer_search: null,
      cancer_list: [],
      cancer_items: [],
      cancer_loading: false,
      cancer_error_message: null,
      cancer_index: 6,
      isShowCancerSearchBox: true,
      cancer_selected_show: 2,
      // cancer_collapse: false,

      // Filter by Gene Name:
      gene_selected: [],
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: "Please enter 1 or more gene names.",
      gene_error_message: null,
      gene_selected_show: 3,

      // Filter by AS Type:
      as_selected: [],
      as_items: ["ES", "A3SS", "A5SS", "IR", "MEX", "Complex"],
      as_selected_show: 3,

      // Filter by Primary Site
      site_selected: [],
      site_select: null,
      site_search: null,
      site_list: [],
      site_items: [],
      site_loading: false,
      site_error_message: null,
      site_index: 6,
      isShowSiteSearchBox: true,
      site_selected_show: 3,

      // Filter by Biological Function
      bio_func_selected: [],
      bio_func_select: null,
      bio_func_search: null,
      bio_func_list: [],
      bio_func_items: [],
      bio_func_loading: false,
      bio_func_error_message: null,
      bio_func_index: 6,
      isShowBioFuncSearchBox: true,
      bio_func_selected_show: 3,

      // Filter by Cell Line
      cell_line_selected: [],
      cell_line_search: null,
      cell_line_list: [],
      cell_line_items: [],
      cell_line_loading: false,
      cell_line_message: null,
      cell_line_error_message: null,
      cell_line_index: 6,
      isShowCellLineSearchBox: true,
      cell_line_selected_show: 3,

      // coordinate_range_selected: [],
      chrList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14',
        '15', '16', '17', '18', '19', '20', '21', '22', 'X', 'Y'],
      chr: null,
      coordinate_start: null,
      coordinate_end: null,

      //yearList
      yearList: ['2022', '2021', '2020',
        '2019', '2018', '2017', '2016',
        '2015', '2014', '2013', '2012',
        '2011', '2010', '2009', '2008',
        '2007', '2006', '2005', '2004',
      ],
      year_selected: null,

      // Filter by Pubmed ID
      pubmed_selected: [],
      pubmed_search: null,
      pubmed_list: [],
      pubmed_items: [],
      pubmed_loading: false,
      pubmed_message: "Please enter 1 or more pubmed names.",
      pubmed_error_message: null,
      pubmed_selected_show: 3,


      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/',
      currentPage: 1,
      whichPage: 1,
      totalPages: 0,
      pageSize: 13,
      pageSizes: [10, 13, 15, 20, 50, 100],
      totalItems: 0,

      selectedHeader: ['Gene Name', 'Cancer Type', 'AS Type',
        'ORF', 'Mechanism', 'Function', 'Year', 'PubMed', 'Journal', 'Visualization',
        'Network', 'Explorer', 'Survival', 'Staging', 'Details'],
      headers: [
        { text: 'Event ID', value: 'event_id', align: 'start', sortable: false, },
        { text: 'AS Model ID', value: 'as_model_id', align: 'start', sortable: false, },
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: true, },
        { text: 'Ensembl ID', value: 'ensembl_id', align: 'start', sortable: true, },
        { text: 'Chromsome', value: 'chr', align: 'start', sortable: false, },
        { text: 'Strand', value: 'strand', align: 'start', sortable: false, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: true },
        { text: 'Canonical Transcript', value: 'ct_ensembl_id', align: 'start', sortable: false, },
        { text: 'Splicing Variant', value: 'sv_ensembl_id', align: 'start', sortable: false, },
        { text: 'AS Type', value: 'as_type', align: 'start', sortable: true, },
        { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', sortable: false, },
        { text: 'Alt Coordinates', value: 'alt_coordinates', align: 'start', sortable: false, },
        // { text: 'Splice In Isoforms', value: 'splice_in_isoforms', align: 'start', sortable: false, },
        // { text: 'Splice Out Isoforms', value: 'splice_out_isoforms', align: 'start', sortable: false, },
        { text: 'ORF', value: 'orf_annotation', align: 'start', sortable: false, },
        { text: 'Method', value: 'methods', align: 'center', sortable: false, },
        { text: 'Mechanism', value: 'regulatory_mechanism', align: 'center', sortable: false, },
        { text: 'Function', value: 'biological_function', align: 'center', sortable: false, },
        { text: 'Primary Site', value: 'primary_site', align: 'start', sortable: false, },
        { text: 'Year', value: 'year', align: 'start', sortable: true, },
        { text: 'PubMed', value: 'pubmed_id', align: 'start', sortable: false, },
        { text: 'Journal', value: 'journal', align: 'start', sortable: false, },
        { text: 'Title', value: 'title', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'center', sortable: false, },
        { text: 'Network', value: 'regulatory_network', align: 'center', sortable: false, },
        { text: 'Explorer', value: 'regulatory_explorer', align: 'center', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'center', sortable: false, },
        { text: 'Staging', value: 'staging', align: 'center', sortable: false, },
        { text: 'Details', value: 'details', align: 'center', sortable: false, },
      ],

      spliceVariant: [],
      // geneInfo: [],
      filters: {
        // gene_name: [],
        // cancer_name: [],
        // canonical_transcript_name: [],
        // splice_variant_name: [],
        // as_type: [],
        // orf_annotation: [],
        // regulatory_mechanism: [],
        // biological_function: [],
        // clinical_application: [],
        // pubmed_id: [],
      },
      filterInfo: 'total',
      groupBy: null,
      splicing_entry_count: 0,
      cancer_subtype_count: 0,
      gene_name_count: 0,
      as_type_count: 0,
      tissue_type_count: 0,
      pubmed_count: 0,

      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      stage_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],

    }
  },
  created() {
    this.getAllCancerFromSV();
    this.getAllPrimarySiteFromSV();
    this.getAllBiologicalFunctionFromSV();
    this.getAllPubmedFromSV();
    this.getAllCellLineFromSV();
    this.getAllGeneFromSV().then(() => {

      if (Object.keys(this.$route.query).length == 0) {
        this.getSpliceKnowledge();
      } else if (Object.keys(this.$route.query).length == 2 && this.$route.query.page && this.$route.query.size) {
        this.currentPage = +this.$route.query.page;
        this.pageSize = +this.$route.query.size;
        this.getSpliceKnowledge();
      } else if (Object.keys(this.$route.query).length >= 3) {
        // console.log(this.$route.query);
        this.currentPage = +this.$route.query.page;
        this.pageSize = +this.$route.query.size;

        if (this.$route.query.cancername) {
          this.cancer_selected = this.$route.query.cancername.split(',');
        }
        if (this.$route.query.genename) {
          this.gene_selected = this.$route.query.genename.split(',');
        }
        if (this.$route.query.astype) {
          this.as_selected = this.$route.query.astype.split(',');
        }
        if (this.$route.query.site) {
          this.site_selected = this.$route.query.site.split(',');
        }
        if (this.$route.query.functional) {
          this.bio_func_selected = this.$route.query.functional.split(',');
        }
        if (this.$route.query.cellline) {
          this.cell_line_selected = this.$route.query.cellline.split(',');
        }
        if (this.$route.query.year) {
          this.year_selected = this.$route.query.year;
        }
        // console.log(this.$route.query.pubmedid);
        if (this.$route.query.pubmedid) {
          this.pubmed_selected = this.$route.query.pubmedid.split(',').map(d => +d);
          // console.log(this.pubmed_selected);
        }
      }
    });
  },
  mounted() {
    // this.getAllCancerFromSV();
    // this.getAllPrimarySiteFromSV();
    // this.getAllBiologicalFunctionFromSV();
    // this.getAllPubmedFromSV();
    // this.getAllCellLineFromSV();
  },
  computed: {

    filteredSpliceVariant() {
      return this.spliceVariant;
    },

    // filteredSpliceVariant() {

    // if (this.$route.query.keyword) {

    // let keyword = this.$route.query.keyword;
    // console.log(keyword);

    // if (keyword == 'regulation') {
    //   this.filterInfo = "Exists Regulatory Mechanism"
    //   return this.spliceVariant.filter((d) => {
    //     return d['regulatory_mechanism'] !== ("" || "-" || "NA")
    //   })
    // }
    // if (keyword == 'function') {
    //   this.filterInfo = "Exists Biological Function"
    //   return this.spliceVariant.filter((d) => {
    //     return d['biological_function'] !== ("" || "-" || "NA")
    //   })
    // }
    // if (keyword == 'clinical') {
    //   this.filterInfo = "Exists Clinical Application"
    //   return this.spliceVariant.filter((d) => {
    //     return d['clinical_application'] !== ("" || "-" || "NA")
    //   })
    // }
    // if (keyword == 'pathway') {
    //   this.filterInfo = "Exists Signaling Pathway"
    //   return this.spliceVariant.filter((d) => {
    //     return d['signaling_pathway'] !== ("" || "-" || "NA")
    //   })
    // }
    // if (keyword == 'inframe') {
    //   return this.spliceVariant.filter((d) => {
    //     return d['orf_annotation'] == "in-frame"
    //   })
    // }
    // if (keyword == 'frameshift') {
    //   return this.spliceVariant.filter((d) => {
    //     return d['orf_annotation'] == "frame-shift"
    //   })
    // }

    // AS type
    // if (keyword == 'ES') {
    //   this.filterInfo = "Splicing Type : ES"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /ES/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }
    // if (keyword == 'A5SS') {
    //   this.filterInfo = "Splicing Type : A5SS"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /A5SS/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }
    // if (keyword == 'A3SS') {
    //   this.filterInfo = "Splicing Type : A3SS"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /A3SS/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }
    // if (keyword == 'IR') {
    //   this.filterInfo = "Splicing Type : IR"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /IR/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }
    // if (keyword == 'MEX') {
    //   this.filterInfo = "Splicing Type : MEX"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /MEX/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }
    // if (keyword == 'Complex') {
    //   this.filterInfo = "Splicing Type : Complex"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /Complex/gi;
    //     return reg.exec(d['as_type']) !== null;
    //   })
    // }

    // Experimental Methods
    // if (keyword == 'pcr') {
    //   this.filterInfo = "Experimental methods : qRT-PCR, RT-PCR, PCR"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /PCR/gi;
    //     return reg.exec(d.methods) !== null;
    //   })
    // }
    // if (keyword == 'western') {
    //   this.filterInfo = "Experimental methods : western blotting"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /western/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'staining') {
    //   this.filterInfo = "Experimental methods : immunohistochemical, immunofluorescence"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /immunohistochemical|immunofluorescence/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'progro') {
    //   this.filterInfo = "Experimental methods : cell proliferation assay, cell growth assay"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /cell proliferation|cell growth/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'apoptosisAssay') {
    //   this.filterInfo = "Experimental methods : apoptosis assay"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /apoptosis/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'miginv') {
    //   this.filterInfo = "Experimental methods : cell migration assay, cell invasion assay"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /migration assay|invasion assay/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'immunoprecipitation') {
    //   this.filterInfo = "Experimental methods : immunoprecipitation"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /immunoprecipitation/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }
    // if (keyword == 'siRNA') {
    //   this.filterInfo = "Experimental methods : siRNA"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /siRNA/gi;
    //     return reg.exec(d['methods']) !== null;
    //   })
    // }

    // Biological Function
    // if (keyword == 'growth') {
    //   this.filterInfo = "Biological Function : cell growth"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /growth/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'proliferation') {
    //   this.filterInfo = "Biological Function : cell proliferation"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /proliferation/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'cycle') {
    //   this.filterInfo = "Biological Function : cell cycle"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /cycle/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'immune') {
    //   this.filterInfo = "Biological Function : immune, inflammation"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /immune|inflammation/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'invasion') {
    //   this.filterInfo = "Biological Function : cell invasion, cell migration"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /invasion|migration/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'EMT') {
    //   this.filterInfo = "Biological Function : EMT, metastasis"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /EMT|metastasis/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'apoptosis') {
    //   this.filterInfo = "Biological Function : apoptosis, autophagy"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /apoptosis|autophagy/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }
    // if (keyword == 'angiogenesis') {
    //   this.filterInfo = "Biological Function : angiogenesis"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /angiogenesis/gi;
    //     return reg.exec(d['biological_function']) !== null;
    //   })
    // }

    // Regulatory Mechanism
    // if (keyword == 'sf') {
    //   this.filterInfo = "Regulatory Mechanism : splicing fator"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /splicing factor/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'rbp') {
    //   this.filterInfo = "Regulatory Mechanism : RNA-binding protein"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /RNA-binding protein/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'mutation') {
    //   this.filterInfo = "Regulatory Mechanism : mutation"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /mutation/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'methylation') {
    //   this.filterInfo = "Regulatory Mechanism : methylation"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /methylation/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'lncRNA') {
    //   this.filterInfo = "Regulatory Mechanism : lncRNA"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /lncRNA/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'microRNA') {
    //   this.filterInfo = "Regulatory Mechanism : microRNA"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /microRNA/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }
    // if (keyword == 'transcription factor') {
    //   this.filterInfo = "Regulatory Mechanism : transcription factor"
    //   return this.spliceVariant.filter((d) => {
    //     const reg = /transcription factor/gi;
    //     return reg.exec(d['regulatory_mechanism']) !== null;
    //   })
    // }


    // Home links
    // if (keyword == 'gene') {
    //   this.filterInfo = this.gene_name_count + " genes"
    //   this.pageSize = 50
    //   this.groupBy = "gene_name"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // if (keyword == 'cancerSubtype') {
    //   this.filterInfo = this.cancer_subtype_count + " cancer subtypes"
    //   this.pageSize = 50
    //   this.groupBy = "cancer_name"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // if (keyword == 'splicingEvent') {
    //   this.filterInfo = this.as_type_count + " splicing events"
    //   this.pageSize = 50
    //   this.groupBy = "as_type"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // if (keyword == 'tissue') {
    //   this.filterInfo = this.tissue_type_count + " tissues"
    //   this.pageSize = 50
    //   this.groupBy = "tissue"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // if (keyword == 'publication') {
    //   this.filterInfo = this.pubmed_count + " publications"
    //   this.pageSize = 50
    //   this.groupBy = "pubmed_id"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // } else {
    //   this.filterInfo = "total"
    //   return this.spliceVariant.filter((d) => {
    //     return Object.keys(this.filters).every((f) => {
    //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //     });
    //   });
    // }
    // },
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    },
    listenMultiData() { // watch multi data props meanwhile.
      const { cancer_selected, gene_selected, as_selected, site_selected, bio_func_selected,
        cell_line_selected, year_selected, pubmed_selected } = this;
      return {
        cancer_selected, gene_selected, as_selected, site_selected, bio_func_selected,
        cell_line_selected, year_selected, pubmed_selected
      }
    }
  },
  watch: {
    spliceVariant(val) {
      if (val) {
        this.loading = false;
      }
    },
    // cancer type
    cancer_select(val) {
      if (val == null || val.length == 0) {
        this.cancer_items == this.cancer_list;
      }
    },
    cancer_search(val) {
      val && val !== this.cancer_select && this.cancerQuerySelections(val);
      if (val == null || val.length == 0) {
        this.cancer_items = this.cancer_list;
      }
    },
    cancer_selected(newVal, oldVal) {
      // if (newVal == null || newVal.length == 0) {
      //   this.getSpliceKnowledge();
      // }
      // console.log(newVal);
      if (newVal.length == 0) {
        this.cancer_selected_show = 2;
      }
      if (newVal !== oldVal) {
        this.currentPage = 1; // default show the first page
        this.getSpliceKnowledge();
      }
    },

    //gene name
    gene_selected(val) {
      // console.log(this.gene_list);
      // console.log(val);
      if (val == null || val.length == 0) {
        this.gene_selected_show = 3; // init the show number
        this.gene_message = "Please enter 1 or more gene names."
        // console.log('hehehe');
        this.currentPage = 1; // default show the first page
        this.getSpliceKnowledge();
        // Check whether each gene of gene_selected is in the gene_list array
      } else if (val && val.length > 0 && val.every(v => this.gene_list.includes(v))) {
        // console.log('hahaha');
        this.gene_selected = val;
        this.gene_message = null;
        this.currentPage = 1; // default show the first page
        this.getSpliceKnowledge();
      } else {
        // window.alert("Sorry, we cant' find the gene you entered.");
        // this.gene_selected = [];
        this.gene_selected && this.gene_selected.pop();
      };
    },
    gene_search(val) {
      val && val !== this.gene_selected && this.geneQuerySelections(val);
    },
    // as type
    as_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.as_selected_show = 3;
      }
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.getSpliceKnowledge();
      }
    },
    // primary site
    site_select(val) {
      if (val == null || val.length == 0) {
        this.site_items == this.site_list;
      }
    },
    site_search(val) {
      val && val !== this.site_select && this.siteQuerySelections(val);
      if (val == null || val.length == 0) {
        this.site_items = this.site_list;
      }
    },
    site_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.site_selected_show = 3;
      }
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.getSpliceKnowledge();
      }
    },
    // biological function
    bio_func_select(val) {
      if (val == null || val.length == 0) {
        this.bio_func_items == this.bio_func_list;
      }
    },
    bio_func_search(val) {
      val && val !== this.bio_func_select && this.bioFuncQuerySelections(val);
      if (val == null || val.length == 0) {
        this.bio_func_items = this.bio_func_list;
      }
    },
    bio_func_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.bio_func_selected_show = 3;
      }
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.getSpliceKnowledge();
      }
    },
    // cell line
    cell_line_selected(val) {
      // console.log(val);
      if (val == null || val.length == 0) {
        this.cell_line_selected_show = 3; // init the show number
        this.cell_line_message = "Please enter 1 or more cell_line names."
        // console.log('hehehe');
        this.currentPage = 1;
        this.getSpliceKnowledge();
        // Check whether each cell_line of cell_line_selected is in the cell_line_list array
      } else if (val && val.length > 0 && val.every(v => this.cell_line_list.includes(v))) {
        // console.log('hahaha');
        this.cell_line_selected = val;
        this.cell_line_message = null;
        this.currentPage = 1;
        this.getSpliceKnowledge();
      } else {
        // window.alert("Sorry, we cant' find the cell_line you entered.");
        // this.cell_line_selected = [];
        this.cell_line_selected && this.cell_line_selected.pop();
      };
    },
    cell_line_search(val) {
      val && val !== this.cell_line_selected && this.cellLineQuerySelections(val);
    },

    // pubmed id
    pubmed_selected(val) {
      // console.log(this.pubmed_list);
      // console.log(val);
      // 延迟 100ms 执行，等待 pubmed_list 请求过来
      setTimeout(() => {
        if (val == null || val.length == 0) {
          this.pubmed_selected_show = 3;
          this.pubmed_message = "Please enter 1 or more PubMed IDs."
          this.currentPage = 1;
          this.getSpliceKnowledge();
          // Check whether each pubmed of pubmed_selected is in the pubmed_list array
        } else if (val && val.length > 0 && val.every(v => this.pubmed_list.includes(v))) {
          // console.log(val);
          this.pubmed_selected = val;
          this.pubmed_message = null;
          this.currentPage = 1;
          this.getSpliceKnowledge();
        } else {
          // window.alert("Sorry, we cant' find the PubMed ID you entered.");
          // this.pubmed_selected = [];
          this.pubmed_selected && this.pubmed_selected.pop();
        };
      }, 100);
    },
    pubmed_search(val) {
      // console.log(val);
      val && !this.pubmed_selected.includes(val) && this.pubmedQuerySelections(val);
    },
    year_selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.getSpliceKnowledge();
      }
    },
    // watch multi data props meanwhile.
    listenMultiData(val) {
      // console.log(val);
      if (val.cancer_selected.length == 0 && val.gene_selected.length == 0 &&
        val.as_selected.length == 0 && val.site_selected.length == 0 &&
        val.bio_func_selected.length == 0 && val.cell_line_selected == 0 &&
        val.year_selected == null && val.pubmed_selected.length == 0) {
        this.isShowTips = true; // Show the tips
      } else {
        this.isShowTips = false;
      }

      // isShowAnd
      // let index = 0;
      // if (val.cancer_selected.length > 0) {
      //   index = index + 1;
      // }
      // if (val.gene_selected.length > 0) {
      //   index = index + 1;
      // }
      // if (val.as_selected.length > 0) {
      //   index = index + 1;
      // }
      // if (val.site_selected.length > 0) {
      //   index = index + 1;
      // }
      // if (val.bio_func_selected.length > 0) {
      //   index = index + 1;
      // }
      // if (val.year_selected) {
      //   index = index + 1;
      // }
      // if (val.pubmed_selected.length > 0) {
      //   index = index + 1;
      // }
      // console.log(index);
      // if (index > 1) {
      //   this.isShowAnd = true
      // } else {
      //   this.isShowAnd = false
      // }
    }
  },
  // beforeDestroy() {
  //   bus.$off('sendData')
  // },
  methods: {
    getRequestParams(genename, cancername, astype, site, functional, cellline, pubmed, year, page, pageSize) {
      let params = {};
      if (genename.length > 0) {
        params["genename"] = genename.join(',');
      }
      if (cancername.length > 0) {
        params["cancername"] = cancername.join(',');
      }
      if (astype.length > 0) {
        params["astype"] = astype.join(',');
      }
      if (site.length > 0) {
        params["site"] = site.join(',');
      }
      if (functional.length > 0) {
        params["functional"] = functional.join(',');
      }
      if (cellline.length > 0) {
        params["cellline"] = cellline.join(',');
      }
      if (pubmed.length > 0) {
        params["pubmedid"] = pubmed.join(',');
      }
      if (year) {
        params["year"] = year;
      }
      if (page) {
        params["page"] = page - 1;
      }
      // console.log(page);
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    async getSpliceKnowledge() {
      this.loading = true;
      const params = this.getRequestParams(
        this.gene_selected,
        this.cancer_selected,
        this.as_selected,
        this.site_selected,
        this.bio_func_selected,
        this.cell_line_selected,
        this.pubmed_selected,
        this.year_selected,
        this.currentPage,
        this.pageSize
      );
      await getSpliceKnowledge(params).then((data) => {
        if (data) {
          // console.log(data.items);

          this.loading = false;
          this.totalItems = data.totalItems;
          this.spliceVariant = data.items;
          this.currentPage = data.currentPage;
          this.totalPages = data.totalPages;

          this.$router.replace({
            path: '/browse/knowledge',
            query: {
              genename: params.genename,
              cancername: params.cancername,
              astype: params.astype,
              site: params.site,
              regulation: params.regulation,
              functional: params.functional,
              cellline: params.cellline,
              pubmedid: params.pubmedid,
              year: params.year,
              eventid: params.eventid,
              page: params.page + 1,
              size: params.size,
            }
          }).catch(err => {
            if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
              console.error(err);
            }
          });
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceKnowledge();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceKnowledge();
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceKnowledge();
    },

    showOrHide() {
      if (this.isShowFilter == true) {
        this.isShowFilter = false
        this.col2 = 12
      } else {
        this.isShowFilter = true
        this.col2 = 9
      }
    },

    // get all cancer types
    async getAllCancerFromSV() {
      await getAllCancerFromSV().then(data => {
        if (data) {
          // console.log(data);
          let cancerNames = [];
          data.forEach((v, i, a) => {
            if (v.indexOf(', ')) {
              let arr = v.split(', ')
              cancerNames.push(...arr)
            } else {
              cancerNames.push(v)
            }
          })
          // console.log(cancerNames);
          this.cancer_list = [...new Set(cancerNames)].filter(a => a.length > 0); // uniq array
          // console.log(this.cancer_list);
          this.cancer_items = this.cancer_list;
        }
      }).catch(err => console.error(err))
    },
    cancerQuerySelections(v) {
      this.cancer_error_message = null;
      this.cancer_loading = true;
      setTimeout(() => {
        this.cancer_items = this.cancer_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.cancer_loading = false;
        // show the no data tips when the search result is null
        if (this.cancer_items.length == 0) {
          this.cancer_error_message = "Sorry, we cant' find the cancer type you entered.";
        }
      }, 500)
    },
    showMoreCancer() {
      this.cancer_index = this.cancer_items.length;
    },
    showLessCancer() {
      this.cancer_index = 6;
    },
    refreshCancer() {
      // console.log(this.cancer_selected);
      this.cancer_selected = [];
    },

    refreshASType() {
      this.as_selected = [];
    },

    // get all gene names
    async getAllGeneFromSV() {
      await getAllGeneFromSV().then(
        data => {
          if (data) {
            // console.log(data);
            this.gene_list = [...data[0], ...data[1]];
            // console.log(this.gene_list);
          }
        }
      ).catch(err => console.error(err))
    },
    geneQuerySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.gene_loading = false
        // show the no data tips when the search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find the gene you entered.";
        }
      }, 500)
    },
    refreshGene() {
      this.gene_selected = [];
    },
    // get all primary sites
    async getAllPrimarySiteFromSV() {
      await getAllPrimarySiteFromSV().then(
        data => {
          if (data) {
            // console.log(data);
            let sites = [];
            data.forEach((v, i, a) => {
              if (v.indexOf(',')) {
                let arr = v.split(', ')
                sites.push(...arr)
              } else {
                sites.push(v)
              }
            })
            // console.log(cancerNames);
            this.site_list = [...new Set(sites)].filter(a => a.length > 0 && a != "-" && a != "NA"); // uniq array
            this.site_items = this.site_list;
          }
        }
      ).catch(err => console.error(err))
    },
    siteQuerySelections(v) {
      this.site_error_message = null;
      this.site_loading = true;
      setTimeout(() => {
        this.site_items = this.site_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.site_loading = false;
        // show the no data tips when the search result is null
        if (this.site_items.length == 0) {
          this.site_error_message = "Sorry, we cant' find the primary site you entered.";
        }
      }, 500)
    },
    showMoreSite() {
      this.site_index = this.site_items.length;
    },
    showLessSite() {
      this.site_index = 6;
    },
    refreshSite() {
      this.site_selected = [];
    },

    // get all Biological Function
    async getAllBiologicalFunctionFromSV() {
      await getAllBiologicalFunctionFromSV().then(
        data => {
          if (data.length > 0) {
            // console.log(data);
            // console.log(data[0].bio_func_category);

            let bio_funcs = data[0].bio_func_category;

            bio_funcs = [...new Set(bio_funcs)].filter(d => { return d != "-" });
            // console.log(bio_funcs);
            // console.log(bio_funcs.sort());

            this.bio_func_list = bio_funcs.sort(); // sort array
            this.bio_func_items = this.bio_func_list;

            // let bio_funcs = [];
            // data.forEach((v, i, a) => {
            //   if (v.indexOf(', ')) {
            //     let arr = v.split(', ')
            //     bio_funcs.push(...arr)
            //   } else {
            //     bio_funcs.push(v)
            //   }
            // });
            // console.log(bio_funcs);
            // bio_funcs = [...new Set(bio_funcs)].filter(a => {
            //   return a.length > 0 && a != "-"
            // })
            // console.log(bio_funcs);
            // console.log(this.bio_func_items);
          }
        }
      ).catch(err => console.error(err))
    },
    bioFuncQuerySelections(v) {
      this.bio_func_error_message = null;
      this.bio_func_loading = true;
      setTimeout(() => {
        this.bio_func_items = this.bio_func_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.bio_func_loading = false;
        // show the no data tips when the search result is null
        if (this.bio_func_items.length == 0) {
          this.bio_func_error_message = "Sorry, we cant' find the biological function you entered.";
        }
      }, 500)
    },
    showMoreBioFunc() {
      this.bio_func_index = this.bio_func_items.length;
    },
    showLessBioFunc() {
      this.bio_func_index = 6;
    },
    refreshBioFunc() {
      this.bio_func_selected = [];
    },

    // get all cell lines
    async getAllCellLineFromSV() {
      await getAllCellLineFromSV().then(data => {
        if (data) {
          // console.log(data);
          let cell_lines = [];
          data.forEach((v, i, a) => {
            if (v.indexOf(',')) {
              let arr = v.split(', ')
              cell_lines.push(...arr)
            } else {
              cell_lines.push(v)
            }
          })
          // console.log(cell_lines);
          this.cell_line_list = [...new Set(cell_lines)].filter(a => a.length > 0 && a != '-'); // uniq array
          this.cell_line_items = this.cell_line_list;
        }
      }).catch(err => console.error(err))
    },
    cellLineQuerySelections(v) {
      this.cell_line_message = null;
      this.cell_line_error_message = null;
      this.cell_line_loading = true;
      setTimeout(() => {
        this.cell_line_items = this.cell_line_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.cell_line_loading = false;
        // show the no data tips when the search result is null
        if (this.cell_line_items.length == 0) {
          this.cell_line_error_message = "Sorry, we cant' find the cell_line type you entered.";
        }
      }, 500)
    },
    refreshCellLine() {
      // console.log(this.cell_line_selected);
      this.cell_line_selected = [];
    },

    // refresh coordinate range
    refreshCoordinateRange() {
      this.chr = null;
      this.coordinate_start = null;
      this.coordinate_end = null;
    },
    // refresh published year_selected
    refreshYear() {
      this.year_selected = null;
    },

    // get all pubmed ids
    async getAllPubmedFromSV() {
      await getAllPubmedFromSV().then(
        data => {
          // console.log(data);
          if (data) {
            this.pubmed_list = data;
          }
        }
      ).catch(err => console.error(err))
    },
    pubmedQuerySelections(v) {
      this.pubmed_message = null;
      this.pubmed_error_message = null;
      this.pubmed_loading = true;
      setTimeout(() => {
        this.pubmed_items = this.pubmed_list.filter(e => {
          let pattern = new RegExp(v + '', 'ig');
          return pattern.test(e + '');
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.pubmed_loading = false
        // show the no data tips when the search result is null
        if (this.pubmed_items.length == 0) {
          this.pubmed_error_message = "Sorry, we cant' find the pubmed you entered.";
        }
      }, 500)
    },
    // refresh pubmed id
    refreshPubmed() {
      this.pubmed_selected = [];
    },
    refreshAll() {
      this.cancer_selected = [];
      this.gene_selected = [];
      this.as_selected = [];
      this.site_selected = [];
      this.bio_func_selected = [];
      this.cell_line_selected = [];
      this.pubmed_selected = [];
      this.year_selected = null;
    },
    addDeleteLine($event) {
      // console.log($event.currentTarget.className);
      // console.log($event.currentTarget.classList);
      // console.log(typeof $event.currentTarget.classList)
      $event.currentTarget.classList.add('show-delete-line');
      // console.log($event.currentTarget.classList)
    },
    removeDeleteLine($event) {
      $event.currentTarget.classList.remove('show-delete-line');
    },

    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the gene name !")
      }
    },
    goToGeneral(genename) {
      this.$router.push({
        path: '/tools/general',
        query: {
          genename: genename
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToDetails(eventid, cancername, pubmedid) {
      this.$router.push({
        path: '/browse/knowledge/details',
        query: {
          eventid: eventid,
          cancername: cancername,
          pubmedid: pubmedid
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToRegulationNetwork(genename) {
      let regulator = genename;
      if (regulator) {
        this.$router.push({
          path: '/tools/regnet',
          query: {
            regulator: regulator,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (regulator == null || regulator == '') {
        window.alert("Sorry, Gene cannot be null.")
      }
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/regexp',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/stage/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    toggleAll() {
      Object.keys(this.$refs).forEach(k => {
        //console.log(this.$refs[k])
        this.$refs[k].$el.click()
      })
    },
    closeAll() {
      Object.keys(this.$refs).forEach(k => {
        // console.log(this.$refs[k])
        if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    openAll() {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Gene Name', 'Cancer Type', 'AS Type',
        'ORF', 'Mechanism', 'Function', 'Year', 'PubMed', 'Journal', 'Visualization',
        'Network', 'Explorer', 'Survival', 'Staging', 'Details'];
    },
    // isCollapseCancer() {
    //   if (this.cancer_collapse == false) {
    //     this.cancer_collapse = true;
    //   } else {
    //     this.cancer_collapse = false;
    //   }
    // },
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.disable-cursor
  cursor: auto

.v-sheet.v-card
  border-radius: 15px

// .theme--light.v-data-table .v-data-footer
//   border-top: 0

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.show-delete-line
  text-decoration: line-through

.pagesize-select
  max-width: 8%

.jump-select
  max-width: 8%

// Narrow the display columns spaces
.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>